/**
 * Skyscraper ad for in the sidebar
 */

// Import statements
import * as React from "react"

/**
 * Define the AdSkyscraper constant
 * @returns {JSX.Element}
 * @constructor
 */
const AdSkyscraper = () => {

    //  return information
    return (
        <div id="banner2-wrapper"></div>
    )
}

/**
 * Export the AdSkyscraper variable
 */
export default AdSkyscraper
